import { FETCH_DEALER_SUCCESS } from 'constants/ActionTypes';
import { FETCH_GROUP_SUCCESS } from 'modules/groups/actionTypes';
import * as types from 'modules/payers/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

/** @typedef {import('utils/ReduxUtils').EntitySlice<import("../types").Payer>} PayerDataEntity */
const payerAdapter = createEntityAdapter({ selectId: ({ id }) => id });

const updateManyFromPage = (state, { payload: { content } }) => payerAdapter.updateMany(state, content);

const updateAfterFetchConfig = (state, { payload: dealer }) => {
  const payers =
    dealer.assignments?.payers?.reduce((acc, { assignedBy, origin, ...payer }) => [...acc, payer], []) ?? [];
  return payerAdapter.updateMany(state, payers);
};

const updateAfterFetchConfigMatcher = ({ type, payload }) =>
  [FETCH_DEALER_SUCCESS, FETCH_GROUP_SUCCESS].includes(type) && payload.projectionType === 'config';

export default createReducer(
  payerAdapter.getInitialState(),
  {
    [types.FETCH_PAYERS_SUCCESS]: updateManyFromPage,
    [types.FILTER_PAYERS_SUCCESS]: updateManyFromPage,
    [types.FETCH_AVAILABLE_PAYERS_SUCCESS]: updateManyFromPage,
    [types.PUT_PAYER_SUCCESS]: payerAdapter.addOne,
    [types.POST_PAYER_SUCCESS]: payerAdapter.addOne,
    [types.FETCH_PAYER_SUCCESS]: payerAdapter.updateOne,
    [types.DELETE_PAYER_SUCCESS]: payerAdapter.removeOne,
  },
  [
    {
      matcher: updateAfterFetchConfigMatcher,
      reducer: updateAfterFetchConfig,
    },
  ]
);
